import { render, staticRenderFns } from "./PlannedLevelSpellsListItem.vue?vue&type=template&id=15616e3c&scoped=true&"
import script from "./PlannedLevelSpellsListItem.vue?vue&type=script&lang=js&"
export * from "./PlannedLevelSpellsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15616e3c",
  null
  
)

export default component.exports